var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "trbo-a-file-upload-wrapper" },
    [
      _c("div", { staticClass: "trbo-a-file-upload__description" }, [
        _vm._v("\n    " + _vm._s(_vm.questionData.description) + "\n  "),
      ]),
      _vm._v(" "),
      _vm.loading ? _c("spinner") : _vm._e(),
      _vm._v(" "),
      !_vm.loading && _vm.files.length
        ? _c(
            "ul",
            { staticClass: "trbo-a-file-upload__file-list" },
            _vm._l(_vm.files, function (file) {
              return _c(
                "li",
                { key: file.id, staticClass: "trbo-a-file-upload__file" },
                [
                  _c("span", [_vm._v(_vm._s(file.name))]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "trbo-a-file-upload__remove-file-button",
                      attrs: {
                        id: "remove_upload_" + file.id,
                        "aria-label": _vm.$t("wizard.removeFile"),
                      },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.$refs.upload.remove(file)
                        },
                      },
                    },
                    [
                      _c("icon", {
                        staticClass: "trbo-a-file-upload__remove-file-icon",
                        attrs: {
                          name: "close",
                          "aria-labelledby": "remove_upload_" + file.id,
                        },
                      }),
                    ],
                    1
                  ),
                ]
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "file-upload",
        {
          ref: "upload",
          class: _vm.classes,
          attrs: {
            "input-id": "file-upload",
            accept: "image/png,image/gif,image/jpeg,image/webp,application/pdf",
            multiple: true,
            drop: true,
            size: _vm.maxFileSizeInBytes,
            "custom-action": _vm.uploadFile,
          },
          on: { "input-file": _vm.inputFile, "input-filter": _vm.inputFilter },
          model: {
            value: _vm.files,
            callback: function ($$v) {
              _vm.files = $$v
            },
            expression: "files",
          },
        },
        [
          _c("icon", {
            staticClass: "trbo-a-file-upload__icon",
            attrs: { name: "upload" },
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "trbo-a-file-upload__drag_drop_text",
              attrs: { id: _vm.uploadLabelId },
            },
            [
              _vm._v(
                "\n      " + _vm._s(_vm.$t("wizard.clickToAddFiles")) + "\n    "
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }